import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Self, input } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable } from 'rxjs';

import { FormControlPipe } from '@shared/pipe';
import { IFormCustomClass } from '@data/schema';

@Component({
    selector: 'app-typehead-input',
    standalone: true,
    imports: [CommonModule, NgSelectModule, ReactiveFormsModule, FormControlPipe],
    templateUrl: './typehead-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeheadInputComponent implements ControlValueAccessor {
    label = input.required<string>();
    placeholder = input<string>('Select or type to search...');
    list = input<any[]>([]);
    labelField = input<string>('name');
    bindField = input<string>('id');
    multiple = input<boolean>(false);
    clearable = input<boolean>(true);
    appendTo = input<string>();
    inputRequiredIndicatorEnabled = input<boolean>(false);
    customClasses = input<IFormCustomClass>({
        formGroup: 'mb-3',
        label: 'form-label fw-medium mb-2',
        input: '',
    });

    @Input() addTagCallback?: (term: string) => Observable<any>;

    constructor(@Self() public ngControl: NgControl) {
        this.ngControl.valueAccessor = this;
    }

    writeValue(_obj: any): void {}
    registerOnChange(_fn: any): void {}
    registerOnTouched(_fn: any): void {}

    readonly addTagFn = (term: string): Promise<any> | false => {
        if (!this.addTagCallback) return false;
        return new Promise<any>((resolve) => {
            this.addTagCallback!(term).subscribe((result) => resolve(result));
        });
    };
}
